/**
 * create by qiaojian on 2017/11/06
 * 对原生ajax进行封装，不依赖jquery、zepto等第三方库
 * */
function buildParams(prefix, obj, add) {
    if (Object.prototype.toString.call(obj) === "[object Array]" || Object.prototype.toString.call(obj) === "[object Arguments]" ) {
        for (var item in obj) {
            buildParams(prefix + "[" + ( item != null ? item : "" ) + "]", obj[item], add);
        }
    }
    else if (Object.prototype.toString.call(obj) === "[object Object]") {
        for (item in obj) {
            buildParams(prefix + "[" + item + "]", obj[item], add);
        }
    }
    else if (Object.prototype.toString.call(obj) === "[object Error]") {
            buildParams(prefix, obj.toString(), add);
    } else {
        add(prefix, obj);
    }
}

/**
 * 对象参数的处理
 * @param data
 * @returns {string}
 */
function getParams(data) {
    var arr = [];
    var add = function (param, data) {
        arr.push(encodeURIComponent(param) + '=' + encodeURIComponent(data));
    };
    for (var param in data) {
        buildParams(param, data[param], add);
    }
    arr.push(('randomNumber=' + Math.random()).replace('.', ""));
    return arr.join('&');

}

/**
 * 原生ajax封装
 * @param url 要请求的url;
 * @param type ajax请求方式(get或post)(默认get);
 * @param data 发送的数据(json格式);
 * @param dataType 返回值类型的设定(默认json)(此功能暂未开放);
 * @param async 是否异步请求(默认为true);
 * @param cache 是否调用缓存(默认为false);
 * @param success 请求成功的回调函数(res,xml);
 * @param fail 请求失败的回调函数(status);
 * @param complete 请求失败的回调函数(res,status);
 */
function modAjax(options) {
    /**
     * 传入方式默认为对象
     * */
    options = options || {};
    /**
     * 默认为GET请求
     * */
    options.type = (options.type || "get").toUpperCase();
    /**
     * 返回值类型默认为json
     * */
    options.dataType = options.dataType || 'json';
    /**
     * 默认为异步请求
     * */
    options.async = options.async || true;
    /**
     * 默认为不缓存ajax
     * */
    options.cache = options.cache || false;
    /**
     * 默认为不缓存ajax
     * */
    options.isNotShowErrorAlert = options.isNotShowErrorAlert || false;

    /**
     * 对需要传入的参数的处理，加上随机数;
     * */
    var params = getParams(options.data);

    /**
     * 创建一个 ajax请求
     * W3C标准和IE标准
     */
    var xhr;
    if (window.XMLHttpRequest) {
        /**
         * W3C标准
         * */
        xhr = new XMLHttpRequest();
    } else {
        /**
         * IE标准
         * @type {ActiveXObject}
         */
        xhr = new ActiveXObject('Microsoft.XMLHTTP')
    }
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 1) {
            //判断是否调用缓存;
            if (!options.cache) {
                xhr.setRequestHeader("Cache-Control", "no-cache");
            }
            //已经调用open方法,但尚未发送请求;
            options.beforeSend && options.beforeSend();
        } else if (xhr.readyState == 2) {
            //请求已经发送完成;
        } else if (xhr.readyState == 3) {
            //可以接收到部分响应数据;
        } else if (xhr.readyState == 4) {
            var status = xhr.status;
            if (status >= 200 && status < 300) {

                if (xhr.responseText && xhr.responseText.errorCode == '800') {
                    //从谷伟伟封装的ajax摘过来的;
                    window.location.href = "/touch/user/loginbymobile?forward=" + escape(location.href);
                } else {
                    /**
                     *ajax请求成功执行回调success;
                     * */
                    options.success && options.success(xhr.responseText, xhr.responseXML);
                }

            } else {
                /**
                 *判断错误状态码;
                 * */
                if (!options.isNotShowErrorAlert) {
                    switch (status + '') {
                        //添加一些常见状态
                        case '404':
                            // 这里要不要改成toast
                            alert('抱歉！好像网络出问题了，请检查您的网络设置');
                            break;
                        case '500':
                            alert('抱歉！好像系统有异常！请联系管理员解决');
                            break;
                        default:
                            alert('抱歉！可能系统出现异常或网络质量不好');
                            break;
                    }
                }

                /**
                 *ajax请求失败执行回调error;
                 * */
                options.error && options.error(status);
            }

            /**
             *当请求完成时执行complete(无论请求成功或失败);
             * */
            options.complete && options.complete(xhr.responseText, status);
        }
    };
    if (options.type == 'GET') {
        /**
         *打开请求
         * */
        xhr.open("GET", options.url + '?' + params, options.async);
        /**
         *GET请求设置请求头
         * */
        xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
        xhr.send(null);
        
    } else if (options.type == 'POST') {
        /**
         *打开请求
         * */
        xhr.open('POST', options.url, options.async);
        /**
         * POST请求设置请求头
         * */
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
        /**
         * 发送请求参数
         */
        xhr.send(params);
    }
    return xhr;
}

module.exports = modAjax;
